export function state(initialState={}) {
  return initialState.content || {
    details: {}
  };
}
